import { useStore } from 'effector-react'
import { useMemo } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { FixButtonWrapper, FormWrapper } from '~/features/Registration/styled'
import { CorrectionField, RecognitionErrorsResponse } from '~/shared/api'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { Button } from '~/shared/ui/Buttons'
import { FormProvider } from '~/shared/ui/form'
import { FieldInput } from './FieldInput'
import {
  extractCorrectionFields,
  getDocumentTypeLabel,
  groupFieldsByDocument,
} from './helpers'
import { FormValues } from './model'
import {
  SectionWrapper,
  SectionTitle,
  FieldWrapper,
  HeaderDescription,
} from './styled'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  form: UseFormReturn<FormValues>
  errorsData?: RecognitionErrorsResponse | null
  isLoading?: boolean
}

export function Form({
  onSuccess,
  form,
  errorsData,
  isLoading = false,
}: FormProps) {
  const featureFlags = useStore(featureFlagModel.$featureFlags)

  const correctionFields = useMemo(
    () => extractCorrectionFields(errorsData || {}),
    [errorsData],
  )

  const groupedFields = useMemo(
    () => groupFieldsByDocument(correctionFields),
    [correctionFields],
  )

  if (!correctionFields?.length) {
    return null
  }

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <FormWrapper>
        <HeaderDescription>
          Некоторые поля не удалось распознать автоматически. Пожалуйста,
          заполните их вручную.
        </HeaderDescription>

        {Object.entries(groupedFields).map(([documentType, fields]) => (
          <SectionWrapper key={documentType}>
            <SectionTitle>
              {getDocumentTypeLabel(
                documentType as CorrectionField['documentType'],
              )}
            </SectionTitle>
            {fields.map((field, key) => (
              <FieldWrapper
                key={`${field.documentType}-${field.fieldName}-${key}`}
              >
                <FieldInput
                  field={field}
                  form={form}
                  enableDaData={featureFlags.address_suggestions_dadata}
                />
              </FieldWrapper>
            ))}
          </SectionWrapper>
        ))}

        <FixButtonWrapper>
          <Button
            loading={isLoading}
            variant='limeFlooded'
            size='large'
            type='submit'
            fullWidth
          >
            Продолжить
          </Button>
        </FixButtonWrapper>
      </FormWrapper>
    </FormProvider>
  )
}
